var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._b({ref:"cell",staticClass:"om-table-cell",class:{'om-table-cell-has-checkbox': _vm.hasCheckbox},attrs:{"colspan":_vm.colspan}},'td',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }